import { Component, EventEmitter, Input, Output, ViewChild, ElementRef, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import { TohumUiModule } from '@anadolu-commons/tohum-ui';
import { SharedService } from '../shared.service';

@Component({
  selector: 'aof-checkbox',
  standalone: true,
  imports: [TohumUiModule],
  providers: [SharedService],
  templateUrl: './checkbox.html',
  styleUrls: ['./checkbox.component.scss']
})

export class CheckboxComponent implements AfterViewInit, OnChanges {

  @ViewChild("parent", { read: ElementRef, static: false }) private thmCheckbox: ElementRef;

  @Input() inputId: string;
  @Input() labelText = 'Default label';
  @Input() value = false;
  @Input() inline = false;
  @Input() disabled = false;
  @Input() labelAlign = 'right';
  @Input() fontBold = false;
  @Input() wasValidated = false;

  @Output() valueChange = new EventEmitter();
  @Output() clearError = new EventEmitter();

  constructor() { 
  }

  ngAfterViewInit(): void {

    let parentElement = this.thmCheckbox.nativeElement;
    let span = parentElement.querySelector("span");

    if (this.fontBold) {
      span.classList.add('font-weight-bold');
    }
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    
    if (this.thmCheckbox === undefined) {

    } 
    else {
      this.setInputValue(this.wasValidated);
    }
  }

  onChange(value: boolean) {

    this.setInputValue(value);

    this.value = value;
    this.valueChange.emit(value);
    this.clearError.emit(value);
  }

  private setInputValue(value: boolean) {

    let parentElement = this.thmCheckbox.nativeElement;
    let input = parentElement.querySelector("input");

    if (value) {
      input.classList.remove('is-invalid'); 
    }
    else {
      input.classList.add('is-invalid');
    }
  }
}

